<template>
  <div :class="[flat ? 'overflow-hidden' : 'rounded-xl border border-line bg-surface shadow-card overflow-hidden', cardClass]">
    <div
      v-if="title || $slots.title || $slots.actions"
      :class="['flex items-center border-b border-line', headerPadding, headerClass]">
      <div class="flex items-center gap-2">
        <span
          v-if="icon"
          class="text-brand">
          <component :is="icon" />
        </span>
        <div>
          <slot name="title">
            <h3
              v-if="title"
              class="text-sm font-semibold text-ink">
              {{ title }}
            </h3>
          </slot>
          <p
            v-if="subtitle"
            class="text-xs text-muted mt-0.5">
            {{ subtitle }}
          </p>
        </div>
      </div>
      <div
        v-if="$slots.actions"
        class="flex items-center gap-2">
        <slot name="actions" />
      </div>
    </div>
    <div :class="[bodyPadding, bodyClass]">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCard',
  props: {
    flat: { type: Boolean, default: false },
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    icon: { type: [Object, Function, String], default: null },
    cardClass: { type: String, default: '' },
    bodyClass: { type: String, default: '' },
    headerClass: { type: String, default: '' },
    headerPadding: { type: String, default: 'px-5 py-4' },
    bodyPadding: { type: String, default: 'p-5' },
  },
}
</script>
